import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import Examine from '@/types/table/examine';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface ExamineData extends Examine {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class ExamineController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<ExamineData>>(API_CONTEXT + '/upms/examine/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<ExamineData>(API_CONTEXT + '/upms/examine/view', params, httpOptions);
  }
  static on(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<ExamineData>(API_CONTEXT + '/upms/examine/on', params, httpOptions);
  }
  static off(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<ExamineData>(API_CONTEXT + '/upms/examine/off', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/examine/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/examine/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/examine/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/examine/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/examine/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/examine/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/examine/deleteBatch', params, httpOptions);
  }
}
